import React, { useState } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import './Navbar.css';
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav>
      <a href="#hero" className="nav-logo">BJN<sup>©2026</sup></a>

      <div className="mobile-menu-btn" onClick={toggleMenu}>
        {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
      </div>

      <div className={`nav-center ${menuOpen ? 'nav-mobile-open' : ''}`}>
        <a href="#about" className="nav-link" onClick={closeMenu}>About</a>
        <a href="#experience" className="nav-link" onClick={closeMenu}>Work</a>
        <a href="#projects" className="nav-link" onClick={closeMenu}>Projects</a>
        <a href="#india-visit" className="nav-link" onClick={closeMenu}>Global Exposure</a>
        <a href="#research" className="nav-link" onClick={closeMenu}>Research</a>
        <a href="#certifications" className="nav-link" onClick={closeMenu}>Certs</a>
        <a href="#blog" className="nav-link" onClick={closeMenu}>Blog</a>
        <a href="#competitions" className="nav-link" onClick={closeMenu}>Competitions</a>
        <a href="#contact" className="nav-link" onClick={closeMenu}>Contact</a>
      </div>

      <div className="nav-status">
        <div className="status-dot"></div>
        Open to Work
      </div>
    </nav>
  );
};

export default Navbar;
